import { AxiosResponse } from "axios";
import { defaultFilterQuery } from ".";
import api from "../apiService";
import { MerchantQuery } from "../queries";
import { ApiResponse } from "types";
import { Merchant } from "features/merchant/types";

export const getMerchantsAPI = async (
	query: MerchantQuery = defaultFilterQuery,
	isCalculate = true,
): Promise<any> => {
	let { skip } = query;
	const { take } = query;
	let endpoint = "/dashboard/merchants/filter";
	if (typeof skip === "number" && take) {
		skip = isCalculate ? skip * take : skip;
		endpoint = `${endpoint}?skip=${skip}&take=${take}`;
	}
	return new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.post(endpoint, query);
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});
};

export const getMerchantStoresAPI = async (
	merchantId: string | number,
	take = 10,
	params?: {
		status?: string;
	},
): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const endpoint = "/dashboard/car-stores";
			const response: AxiosResponse = await api.get(endpoint, {
				merchant: merchantId,
				take: take,
				...params,
			});
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getStoreDetailAPI = async (id: string): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const endpoint = `/dashboard/car-stores/${id}`;
			const response: AxiosResponse = await api.get(endpoint);
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getMerchantSaleReportAPI = async (id: string): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const endpoint = `/dashboard/merchants/report/${id}`;
			const response: AxiosResponse = await api.get(endpoint);
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getSubscriptionPakagesAPI = (): Promise<ApiResponse<any[]>> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<any[]>>("/dashboard/subscription-packages")
			.then(res => resolve(res.data))
			.catch(err => reject(err));
	});

export const updateMerchantSubscriptionPakageAPI = (
	merchantId: number,
	subscriptionClass: number,
	transaction?: {
		quotation: number;
		method: string;
		note: string;
		voucherId?: string;
		files?: any[];
	},
): Promise<ApiResponse<any>> =>
	new Promise((resolve, reject) => {
		api
			.patch<ApiResponse<any>>(
				`/dashboard/merchants/${merchantId}/subscriptions`,
				{
					subscriptionClass,
					transaction,
				},
			)
			.then(res => resolve(res.data))
			.catch(err => reject(err));
	});

export const getMerchantDetail = async ({ id }: { id: string | number }) => {
	try {
		const res = await api.get<ApiResponse<Merchant>>(
			"/dashboard/merchants/" + id,
		);
		return res.data.data;
	} catch (error) {
		return null;
	}
};
